import React from "react";
var __jsx = React.createElement;
import AwesomeIcon from "../AwesomeIcon";
var IconWithCount = function IconWithCount(_ref) {
  var count = _ref.count,
    icon = _ref.icon,
    iconClassNames = _ref.iconClassNames;
  return /*#__PURE__*/React.createElement("span", {
    className: "relative"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: icon,
    size: "lg",
    className: iconClassNames
  }), count ? /*#__PURE__*/React.createElement("div", {
    className: "absolute -top-1 -right-3 bg-red-500 dark:bg-red-500 text-white dark:text-white text-sm rounded-full w-5 h-5 flex items-center justify-center"
  }, count) : null);
};
export default IconWithCount;